import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M.754,9.245a2.582,2.582,0,0,1,0-3.645l.59-.59A.75.75,0,1,1,2.4,6.071l-.589.59a1.078,1.078,0,0,0,0,1.523,1.1,1.1,0,0,0,1.523,0l.878-.878A.75.75,0,0,1,5.277,8.367L4.4,9.245A2.577,2.577,0,0,1,.754,9.245Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.422,7.654a.75.75,0,0,1,0-1.5A1.077,1.077,0,1,0,7.422,4h-1a.75.75,0,0,1,0-1.5h1a2.577,2.577,0,0,1,0,5.154Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.249,2.5a.75.75,0,0,1-.75-.75v-1A.75.75,0,0,1,5,.75v1A.75.75,0,0,1,4.249,2.5Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.914,3.671l-1-.5a.75.75,0,1,1,.671-1.342l1,.5a.75.75,0,0,1-.671,1.342Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }